import PendingToBeConfirmedIcon from './PendingToBeConfirmedIcon'

export default PendingToBeConfirmedIcon
